import React from "react";
import ReactDOM from "react-dom/client";
// DOM guard first: it must wrap removeChild/insertBefore before React mounts.
import "@/lib/domGuard";
import "@/index.css";
// Account colour themes (Personalización › Apariencia): overrides that only
// apply under html[data-zb-theme], so the classic look is untouched.
import "@/uiTheme.css";
import "@/lib/i18n";
import { installApiAuth } from "@/lib/apiAuth";
import App from "@/App";

// Calls to the billing API carry the session of whoever is signed in.
installApiAuth();

// Disable the right-click context menu site-wide (mild deterrent against casual
// copying — it is NOT a security boundary). Editable fields keep their native
// menu so users can still right-click → paste an IBAN, address, etc. Skipped in
// development so DevTools "Inspect" stays reachable.
if (process.env.NODE_ENV === "production") {
  document.addEventListener("contextmenu", (e) => {
    if (e.target.closest('input, textarea, select, [contenteditable="true"]')) return;
    e.preventDefault();
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register the PWA service worker (enables install + Android TWA packaging).
// Auto-update: when a new service worker takes control, reload once so the
// installed app always shows the latest deploy instead of stale cached code.
if ("serviceWorker" in navigator) {
  // Was this page load already under a worker's control?
  //
  // On a FIRST visit it is not: the freshly installed worker's clients.claim()
  // still fires controllerchange, and reloading on that made every new visitor
  // (and every incognito/cleared-cache open) load the whole app twice for
  // nothing — the page had just come straight from the network, so the worker
  // taking over has nothing newer to give.
  //
  // Only a controller SWAP — a new build's worker taking over a page that was
  // already controlled — means the code on screen is stale. That is the case
  // the reload exists for, and it still fires.
  const wasControlled = !!navigator.serviceWorker.controller;
  let reloading = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (!wasControlled || reloading) return;
    reloading = true;
    window.location.reload();
  });

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").then((reg) => {
      // Check for a new version on load and roughly hourly while the app is open.
      reg.update().catch(() => {});
      setInterval(() => reg.update().catch(() => {}), 60 * 60 * 1000);
      // When a new worker has installed and we already control the page, activate it.
      reg.addEventListener("updatefound", () => {
        const sw = reg.installing;
        if (!sw) return;
        sw.addEventListener("statechange", () => {
          if (sw.state === "installed" && navigator.serviceWorker.controller) {
            sw.postMessage("SKIP_WAITING");
          }
        });
      });
    }).catch(() => {});
  });
}
